import Entity from "./Entity";

export default class EventEntity extends Entity {

    constructor(anchor, texture, altTexture1, altTexture2) {
        super(anchor, texture);

        this._originalTexture = texture;

        this._altTexture1 = altTexture1;
        this._altTexture2 = altTexture2;

        this._activated = false;

    }

    update(dt) {

    }

    activate() {
        if (!this._activated) {
            this._view.texture = this._altTexture1;
            this._activated = true;
        }
    }

    deactivate() {
        if (!this._deactivated) {
            this._view.texture = this._altTexture2 ? this._altTexture2 : this._originalTexture;
            this._deactivated = true;
        }
    }

}